import React, { useState } from "react";
import { HOME } from "@/constants/testIds";
import { Activity } from "lucide-react";

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const nav = [
    { label: "Product", id: HOME.navLinkProduct, href: "#why" },
    { label: "Workspace", id: HOME.navLinkWorkspace, href: "#workspace" },
    { label: "Pricing", id: HOME.navLinkPricing, href: "#outcomes" },
    { label: "Docs", id: HOME.navLinkDocs, href: "#faq" },
  ];
  return (
    <header className="sticky top-0 z-50">
      <div className="absolute inset-0 backdrop-blur-xl bg-[hsla(40,33%,97%,0.78)] border-b border-ink-10" />
      <div className="container-narrow relative flex h-16 items-center justify-between">
        <a
          href="#top"
          data-testid={HOME.navLogo}
          className="flex items-center gap-2 font-display font-semibold ink"
        >
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-ink text-[hsl(var(--ivory))]">
            <Activity className="h-4 w-4" />
          </span>
          <span className="text-[15px] tracking-tight">DeMaxtore</span>
          <span className="hidden sm:inline text-xs ink-soft font-mono ml-1">/ Live Shipment Tracking™</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <a
              key={n.id}
              href={n.href}
              data-testid={n.id}
              className="text-[13px] ink-soft hover:ink transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#login"
            data-testid={HOME.navCtaLogin}
            className="hidden sm:inline-flex text-[13px] ink-soft hover:ink px-3 py-2 rounded-lg transition-colors"
          >
            Sign in
          </a>
          <a
            href="#start"
            data-testid={HOME.navCtaStart}
            className="inline-flex items-center gap-1.5 text-[13px] font-medium bg-ink text-[hsl(var(--ivory))] px-4 py-2 rounded-lg hover:bg-[hsla(222,47%,12%,1)] transition-colors"
          >
            Start Tracking
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </header>
  );
};
